import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'
import Nosotros from '../pages/Nosotros.vue'
import Proyectos from '../pages/Proyectos.vue'
import Samara from '../pages/Samara.vue'
import Eliza from '../pages/Eliza.vue'
import Alex from '../pages/Alexandra.vue'
import Isa from '../pages/Isabella.vue'
import Contacto from '../pages/ContactPage.vue'

Vue.use(Router)

 
export default new Router({
  mode: 'history',
 
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home 
    },
    {
        path: '/nosotros',
        name: 'nosotros',
        component: Nosotros 
    },
    {
        path: '/proyectos',
        name: 'proyectos',
        component: Proyectos 
    },
    {
        path: '/samara',
        name: 'samara',
        component: Samara 
    },
    {
        path: '/samara/eliza',
        name: 'eliza',
        component: Eliza 
    },
    {
        path: '/samara/alexandra',
        name: 'alexandra',
        component: Alex 
    },
    {
        path: '/samara/isabella',
        name: 'isabella',
        component: Isa 
    },
    {
        path: '/contacto',
        name: 'contacto',
        component: Contacto 
    }
  ]
})

